export default __webpack_public_path__ + "static/language-b7be464dbf7eeaf741c41c86cb5fdefa.svg";